import { mainAxios } from "../../mainAxios";
import { getDefaultHeaders, getErrorMessage } from "../mainService";

export const getSiniestroByAlianzaId = async (alianzaId) => {
  try {
    console.log({alianzaId})
    const response = await mainAxios.get(
      `v1/siniestro/alianza-list/${alianzaId}`,
      getDefaultHeaders()
    );

    return response.data;
  } catch (error) {
    throw new Error(getErrorMessage(error));
  }
};


